import { Input, Select } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type DistributorCreateViewModel from "viewModels/timeCharges/distributors/distributorManagement/distributorCreateViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import type DistributorDetailViewModel from "viewModels/timeCharges/distributors/distributorManagement/distributorDetailViewModel";
import { FormLabelWithTooltip } from "controls/formLabelWithTooltip";

export interface DistributorFormProps {
  vm: DistributorCreateViewModel | DistributorDetailViewModel;
  children?: React.ReactNode;
}

const DistributorForm = observer((props: DistributorFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="shortName">
          <FormLabel>{vm.translateAttribute("shortName")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="type">
          <FormLabel>{vm.translateAttribute("type")}</FormLabel>
          <Select mode="key" items={vm.distributorTypeOptions} disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="status">
          <FormLabel>{vm.translateAttribute("status")}</FormLabel>
          <Select mode="key" items={vm.distributorStatusOptions} disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="dueDays">
          <FormLabel>{vm.translateAttribute("dueDays")}</FormLabel>
          <Input disabled={disabled} type="number" />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="safeExposure">
          <FormLabelWithTooltip tooltipText={vm.translate("safeExposureTooltip")}>
            {vm.translateAttribute("safeExposure")}
          </FormLabelWithTooltip>
          <Input disabled={disabled} type="number" />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="email">
          <FormLabel>{vm.translateAttribute("email")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="creditExposureWarningPercentage">
          <FormLabelWithTooltip tooltipText={vm.translate("creditExposureWarningPercentageTooltip")}>
            {vm.translate("creditExposureWarningPercentageLabel")}
          </FormLabelWithTooltip>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default DistributorForm;
